// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extraction{
    background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);

}
.extraction__container{
    width: 1150px;
    height: 100%;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    align-items: center;
    @media screen and (max-width: 600px) {
        flex-direction: column;
        width: 100%;
       } 
}
.extraction__left{
    display: flex;
  
    flex-direction: column;
    justify-content: center;
}
.extraction__right{
    display: flex;
    /* flex-direction: column; */
  
    width: 100%;
    padding: 35px 0 80px 0;
    @media screen and (max-width: 600px) {
        margin-left: 0;
        
       } 
}
.extraction__img{
    width: 600px;
    height: 400px;
    @media screen and (max-width: 600px) {
        width: 100%;
        
       } 
}
.extraction__title{
    text-align: left;
    color: #1E1C1A;
    font-family: Roboto;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 50px;
    margin: 0;
}
.extraction__text{
    color: #1E1C1A;
    font-family: Roboto;
    font-size: 19px;
    letter-spacing: 0;
    line-height: 30px;
    margin-top: 35px;
    text-align: left;
}
.extraction__line{

    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    margin-right: 30px;
    margin-left: -50px;
    margin-top: -230px;
    height: 1px;
    width: 30px;
    background-color: #E8483E;
    z-index: 1;
    @media screen and (max-width: 900px) {
       display: none;
       } 
}`, "",{"version":3,"sources":["webpack://./src/components/Extraction/Extraction.css"],"names":[],"mappings":"AAAA;IACI,iFAAiF;;AAErF;AACA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB;QACI,sBAAsB;QACtB,WAAW;OACZ;AACP;AACA;IACI,aAAa;;IAEb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,4BAA4B;;IAE5B,WAAW;IACX,sBAAsB;IACtB;QACI,cAAc;;OAEf;AACP;AACA;IACI,YAAY;IACZ,aAAa;IACb;QACI,WAAW;;OAEZ;AACP;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV;OACG,aAAa;OACb;AACP","sourcesContent":[".extraction{\n    background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);\n\n}\n.extraction__container{\n    width: 1150px;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    margin: 0 auto;\n    align-items: center;\n    @media screen and (max-width: 600px) {\n        flex-direction: column;\n        width: 100%;\n       } \n}\n.extraction__left{\n    display: flex;\n  \n    flex-direction: column;\n    justify-content: center;\n}\n.extraction__right{\n    display: flex;\n    /* flex-direction: column; */\n  \n    width: 100%;\n    padding: 35px 0 80px 0;\n    @media screen and (max-width: 600px) {\n        margin-left: 0;\n        \n       } \n}\n.extraction__img{\n    width: 600px;\n    height: 400px;\n    @media screen and (max-width: 600px) {\n        width: 100%;\n        \n       } \n}\n.extraction__title{\n    text-align: left;\n    color: #1E1C1A;\n    font-family: Roboto;\n    font-size: 40px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 50px;\n    margin: 0;\n}\n.extraction__text{\n    color: #1E1C1A;\n    font-family: Roboto;\n    font-size: 19px;\n    letter-spacing: 0;\n    line-height: 30px;\n    margin-top: 35px;\n    text-align: left;\n}\n.extraction__line{\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 30px;\n    margin-right: 30px;\n    margin-left: -50px;\n    margin-top: -230px;\n    height: 1px;\n    width: 30px;\n    background-color: #E8483E;\n    z-index: 1;\n    @media screen and (max-width: 900px) {\n       display: none;\n       } \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
